import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Card, CardActionArea, CardContent, Modal } from '@mui/material';
import React from 'react';
import { CharacterImageVariant, ImageContainerShape, renderCharacterImage, } from '../image/index.js';
export function ProfileImage(props) {
    const { character } = props;
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const handleOpen = React.useCallback(() => setIsModalOpen(true), []);
    const handleClose = React.useCallback(() => setIsModalOpen(false), []);
    return (_jsxs(_Fragment, { children: [_jsx(Card, { sx: { height: '100%' }, children: _jsx(CardActionArea, { onClick: handleOpen, sx: { height: '100%' }, children: _jsx(CardContent, { sx: {
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            p: 2,
                        }, children: renderCharacterImage(character, {
                            maxWidthInPixels: 250,
                            maxHeightInPixels: 300,
                            containerShape: ImageContainerShape.RoundedRectangle,
                            variant: CharacterImageVariant.Profile,
                        }) }) }) }), _jsx(Modal, { open: isModalOpen, onClose: handleClose, "aria-label": `${character.name} full image`, children: _jsx(Box, { sx: {
                        position: 'absolute',
                        left: '50%',
                        top: '50%',
                        transform: 'translate(-50%, -50%)',
                        outline: 'none',
                    }, onClick: handleClose, children: renderCharacterImage(character, {
                        maxWidthInPixels: window.innerWidth * 0.85,
                        maxHeightInPixels: window.innerHeight * 0.85,
                        containerShape: ImageContainerShape.RoundedRectangle,
                        variant: CharacterImageVariant.Full,
                    }) }) })] }));
}
//# sourceMappingURL=ProfileImage.js.map